const PlaceholderVNode = (props) => {
    return props.node;
};

PlaceholderVNode.props = {
    node: {
        required: true,
    },
};

export default PlaceholderVNode;